<template>
    <div class="p-2 items-start flex flex-col">
        <div class="text-lg text-gray-900 font-bold hyphens-auto">
            <div class="flex gap-1">
                <slot name="additional-content"></slot>
                <TextLink :to="props.linkTarget">
                    {{ props.linkText }}
                </TextLink>
            </div>
        </div>
        <p class="text-sm text-gray-500 font-light">
            <slot name="subtitle"></slot>
        </p>
    </div>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';
import TextLink from '../TextLink/TextLink.vue';

type CardRowLinkWithSubtitleProps = {
    linkText: string;
    linkTarget: RouteLocationRaw;
};

const props = defineProps<CardRowLinkWithSubtitleProps>();
</script>
